import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { ChatServices } from '@app/services/chat.service';
import { DocumentService } from '@app/services/document.service';
import { ChatType } from '@common/enums/ChatType';
import { DocumentStatus } from '@common/enums/DocumentStatus';
import { UploadType } from '@common/enums/UploadType';
import { IChat } from '@common/models/Chat/IChat';
import { IChatDocument } from '@common/models/Chat/IChatDocument';
import { IDeltaTable } from '@common/models/Document/IDeltaTable';
import { IDocument } from '@common/models/Document/IDocument';
import { IESGDocuments } from '@common/models/Document/IESGDocuments';
import { ITableTag } from "@common/models/ITags";
import { MessageService } from 'primeng/api';
import cloneDeep from 'lodash/cloneDeep';

import {
  Subject,
  Subscription,
  debounceTime,
  distinctUntilChanged,
} from 'rxjs';
import { EsgFiltersComponent } from './esg-filters/esg-filters/esg-filters.component';
import { removeDuplicateDocumentsUsingMap } from '@app/utils/removeDuplicateDocumentsUsingMap';

@Component({
  selector: 'app-document-list-siderbar',
  templateUrl: './document-list-siderbar.component.html',
  styleUrls: ['./document-list-siderbar.component.scss'],
  providers: [MessageService],

})
export class DocumentListSiderbarComponent
  implements OnInit, OnDestroy, OnChanges
{
  @ViewChild(EsgFiltersComponent) esgFiltersComponent: EsgFiltersComponent;
  @Input() activeChat: IChat;
  @Input() sidebarVisible: boolean = false;
  docsList: IDocument[] = [];
  organizedDocsList: IDocument[] = [];
  deltaTablesList: IDeltaTable[] = [];
  activeTabIndex: number = 0;
  getAllDocsSub: Subscription = new Subscription();
  getUnqCategoriesSub : Subscription = new Subscription();
  searchText: string;
  searchTextUpdate = new Subject<any>();
  displayedColumns: { header: string; field: string }[] = [
      { header: 'Name', field: 'documentName' },
  ];
  pageSize:number=15;
  pageSizeTables:number=15;
  isloading: boolean = true;
  isloadingTables: boolean = true;
  addingDocLoader:boolean=false;
  selectedDocs: IDocument[] = [];
  selectedTables: IDeltaTable[] = [];
  scrollUpdate = new Subject<any>();
  documentArchived: DocumentStatus = DocumentStatus.Archived;
  expandedFolders: { [key: string]: boolean } = {};
  @Output() emitChangeSelectedDocuments: EventEmitter<IDocument[] | []> =
      new EventEmitter();
  @Output() emitChangeSelectedDeltaTables: EventEmitter<IDeltaTable[] | []> =
      new EventEmitter();
  @Output() emitChangeSelectedESGFilters: EventEmitter<Record<string,any>> =
      new EventEmitter();
  @Output() closeDialog: EventEmitter<boolean> =
      new EventEmitter();
  showLoadMore: boolean = true;
  showLoadMoreTables : boolean = true;
  loadmoreLoadingTables: boolean = false;
  loadmoreLoading: boolean = false;
  QECChatType : ChatType = ChatType.QEC;
  ESGChatType : ChatType = ChatType.ESG;
  expandedESGRowKeys: { [key: string]: boolean } = {};
  excelType = [
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-excel'
    ]
    csvType=[
      'text/csv'
    ]
    StructuredType = [
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/vnd.ms-excel',
      'text/csv'
    ]
    nonStructuredType = [
      'application/pdf',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'application/vnd.ms-powerpoint',
      'application/vnd.openxmlformats-officedocument.presentationml.presentation',
      'text/plain'
    ]
  unqTableCategories :string[] = [];
  tablesListByCategory :any[] = []
  @Input() chatInteractionCount:number = 0 ;


  constructor(private docService: DocumentService,public chatService: ChatServices, private messageService: MessageService ) {
      this.searchTextUpdate
          .pipe(debounceTime(1000), distinctUntilChanged())
          .subscribe((value) => {
              if(this.searchText.trim()!='' || (this.searchText.length==0 && value.key=="Backspace")){
                  if(this.activeTabIndex===1){
                    this.isloadingTables = true;
                    this.getAllDeltaTables('search')
                  }else{
                    this.isloading = true;
                    this.getAllDocs('search');
                  }
              }
          });
      this.scrollUpdate
          .pipe(debounceTime(300), distinctUntilChanged())
          .subscribe((value) => {
              this.scrollLazyLoad(value);
          });
  }

  ngOnInit(): void {
      this.isloading=true
      this.isloadingTables = true
      this.selectedDocs = [];
      this.selectedTables = []
  }

  ngOnChanges(changes: SimpleChanges) {
      if (changes['activeChat'] && this.sidebarVisible==true) {

          this.selectedDocs = [];
          this.selectedTables = [];

          if (this.activeChat && !this.isQECChat() && this.getChatType() !== ChatType.ESG) {
              this.getAllDocs();
          }
          if(this.getChatType() === ChatType.ESG){
            this.isloading = true
            this.getUniqueCategoriesTables();
          }
          if(this.isQECChat){
            this.getAllDeltaTables()
          }
      }
      if(changes['sidebarVisible']?.currentValue===true){
          this.selectedDocs = [];
          this.selectedTables = [];
          this.searchText=""
          this.isloading=true
          this.isloadingTables = true
          if( !this.activeChat || (this.activeChat?.chatDocument?.length === 0 && this.activeChat?.chatTables?.length===0)){
            this.activeTabIndex = 0
            // this.getAllDeltaTables()
            if(this.chatService.getChatType()=== ChatType.ESG){
              if(this.activeChat?.chatTables?.length > 0 || !this.activeChat){
                this.getUniqueCategoriesTables()
              }
              if(this.chatInteractionCount !== 0 || this.activeChat?.ESGTableTags?.length > 0 || this.activeChat?.chatConfig?.ESGChat){
                this.activeTabIndex = 1
              }
            }else{
              this.getAllDocs()
            }
          }else{
            if(this.activeChat?.chatTables?.length > 0){
              if(this.activeChat?.chatType === ChatType.QEC){
                this.getAllDeltaTables()
                this.activeTabIndex = 1
              }
              if(this.activeChat?.chatType === ChatType.ESG){
                this.getUniqueCategoriesTables()
                this.populateESGChatTables(this.activeChat)
                this.activeTabIndex = 0
              }

            }else{
              this.getAllDocs()
              this.activeTabIndex = 0

            }
          }
      }
  }

  isQECChat(){
    return this.chatService.getChatType()===ChatType.QEC || this.activeChat?.chatTables.length > 0
  }

  getChatType(){
    return this.chatService.getChatType()
  }

  onTabChange(event: any) {
    this.activeTabIndex = event.index
    if(this.getChatType() !== this.ESGChatType){
      if(this.activeTabIndex === 1){
        this.getAllDeltaTables()
      }else{
        this.getAllDocs()
      }
    }
    this.selectedTables = []
    if(this.activeTabIndex === 0 && this.getChatType() === this.ESGChatType){
      this.getUniqueCategoriesTables()
    }
    this.searchText = ''
  }

  ngOnDestroy() {
      this.getAllDocsSub && this.getAllDocsSub.unsubscribe();
      this.getUnqCategoriesSub && this.getUnqCategoriesSub.unsubscribe();
  }

  toggleFolder(folderId: string) {
    this.expandedFolders[folderId] = !this.expandedFolders[folderId];
  }

  getAllDocs(type?: string, pageSize?: any) {
    if (pageSize) {
      this.pageSize = pageSize
    }
    else {
      this.pageSize = 25
    }
    this.showLoadMore = true;
    let tempSelectedDocs = this.selectedDocs
    let params = {
      pageSize: this.pageSize,
    };
    if (type == 'loadmore') {
      this.loadmoreLoading = true;
      params['loadMore'] = true
      params['markerId'] = this.docsList[this.docsList.length - 1]['_id'];

    }
    if (type == 'search') {
      (params['search'] = this.searchText);
    }
    if (type == 'reload') {
      params.pageSize = this.docsList.length;
      if (this.searchText?.trim() != '') {
        (params['search'] = this.searchText);
      }
    }

    this.getAllDocsSub.add(
      this.docService.getAllDocs(params).subscribe({
        next: (response: IDocument[]) => {
          if (response && response.length > 0 && (response[response.length - 1]['inFolder'] === true || response && response[response.length - 1].type === 'Folder')) {
            // const tempPageSize = this.pageSize + 15
            this.docsList = [...cloneDeep(response)]
            this.organizeDocuments();
            this.getAllDocs('loadmore')
          }
          else {
            this.loadmoreLoading = false;

            if (type == 'reload' || type == 'search' || type == 'upload') {
              this.docsList = [...cloneDeep(response)]
              this.organizeDocuments();

            } else {
              this.docsList = [...cloneDeep(this.docsList), ...cloneDeep(response)];
              this.organizeDocumentsLoadMore(cloneDeep(response))

            }
              this.isloading = false
            if (response.length < this.pageSize) {
              this.showLoadMore = false;
            }
            let checkInprogress = [];
            this.selectedDocs = []
            if (tempSelectedDocs?.length > 0 && this.docsList.length > 0) {
              tempSelectedDocs?.map((e: IDocument) => {
                const foundItem = this.docsList.find(
                  (chatDocs: IDocument) =>
                    chatDocs.documentId === e.documentId
                );
                if (foundItem) {
                  this.selectedDocs.push(foundItem);
                }
              });
            }
          }

        },
        error: (error) => {
          this.loadmoreLoading = false;
          this.isloading = false;
        },
      })
    );
  }


  organizeDocuments() {
    const folders: any = this.docsList.filter(doc => doc.type === 'Folder');
    const files = this.docsList.filter(doc => doc.type === 'file' && !folders.some(folder => folder.files.includes(doc.documentId)));

    folders.forEach(folder => {
      folder['files'] = this.docsList.filter(doc => folder.files.includes(doc.documentId));
    });

    this.organizedDocsList = [...folders, ...files];
  }

  organizeDocumentsLoadMore(response: any) {
    const folders: any = (response.filter(doc => doc.type === 'Folder'));
    const files = response.filter(doc => doc.type === 'file' && !folders.some(folder => folder.files.includes(doc.documentId)));

    folders.forEach(folder => {
      folder['files'] = response.filter(doc => folder.files.includes(doc.documentId));
    });

    this.organizedDocsList = [...this.organizedDocsList, ...folders, ...files];
  }

  onCloseSidebar() {
      this.closeDialog.emit(true);
  }


  addDocs(){
    if(this.chatService.chatType === this.ESGChatType){
      this.esgFiltersComponent.addDocs()
    }else{
      this.addingDocLoader=true

      const uniqueDocs = removeDuplicateDocumentsUsingMap(this.selectedDocs);
      this.selectedDocs = cloneDeep(uniqueDocs)
      const selectedDocs = this.selectedDocs
      if(this.isQECChat() || (this.selectedTables.length > 0 && this.selectedDocs.length == 0) || this.getChatType() === ChatType.ESG){
        this.emitChangeSelectedDeltaTables.emit(this.selectedTables)
      }else{
        this.selectedDocs
        let DocsPayload: IChatDocument[] = []
        let uniqueDocs = new Set<string>();
        this.selectedDocs.forEach((e: IDocument) => {
          if (e.type !== UploadType.Folder) {
            let uniqueIdentifier = `${e.documentId}-${e.documentName}`;
            if (!uniqueDocs.has(uniqueIdentifier)) {
              uniqueDocs.add(uniqueIdentifier);
              DocsPayload.push(e);
            }
          }
        });
        this.emitChangeSelectedDocuments.emit(selectedDocs);
      }}
  }

  scrollLazyLoad(event) {
      let scrollHeightArr = [];
      let shMin = event.target.scrollHeight - 5;
      let shMax = event.target.scrollHeight + 5;
      for (let i = shMin; i < shMax; i++) {
          scrollHeightArr.push(i);
      }
      let temp =  scrollHeightArr.indexOf(
        Math.ceil(event.target.offsetHeight + event.target.scrollTop)
    )
      if (
          scrollHeightArr.indexOf(
              Math.ceil(event.target.offsetHeight + event.target.scrollTop)
          ) >= 0 &&
          ((this.showLoadMore && !this.isQECChat()) || (this.showLoadMoreTables && this.isQECChat()))
      ) {
          if(this.isQECChat()){
            this.getAllDeltaTables('loadmore')
          }else{
            this.getAllDocs('loadmore');
          }
      }
  }

  onRowSelect(event: any) {
    if (event.data.type === 'Folder') {
      this.selectFolder(event.data);
    } else {
      this.selectedDocs.push(event.data);
    }
  }

  onRowUnselect(event: any) {
    if (event.data.type === 'Folder') {
      this.deselectFolder(event.data);
    } else {
      const index = this.selectedDocs.indexOf(event.data);
      if (index >= 0) {
        this.selectedDocs.splice(index, 1);
      }
    }
  }

  selectFolder(folder: any) {
    if (folder.type === 'Folder') {
        const folderFiles = folder.files;

        const isFileTypeInList = (fileType: string, typeList: string[]) => typeList.includes(fileType);


        // Determine the type of the first file in the folder
        const firstFileType = folderFiles[0]?.contentType;

        const firstFileTypeGroup = isFileTypeInList(firstFileType, this.StructuredType) ? 'StructuredType' :
                               isFileTypeInList(firstFileType, this.nonStructuredType) ? 'nonStructuredType' :
                               null;

            if (firstFileTypeGroup) {
            // Check if all files are of the same type group
            const allSameTypeGroup = folderFiles.every((file: any) =>
                isFileTypeInList(file.contentType, this[firstFileTypeGroup])
            );

            if (allSameTypeGroup) {
                folderFiles.forEach((file: any) => {
                    if (this.selectedDocs.length <= 10 && !this.selectedDocs.includes(file)) {
                        this.selectedDocs.push(file);
                    }
                });
            } else {
                // show a message if the folder contains mixed types
                this.messageService.add({
                    severity: 'warn',
                    summary: 'Mixed File Types',
                    detail: 'The folder contains mixed file types. Please select files of the same type.',
                });
            }
        } else {
            // show a message if the folder contains unsupported file types
            this.messageService.add({
                severity: 'warn',
                summary: 'Unsupported File Types',
                detail: 'The folder contains unsupported file types. Please select supported file types.',
            });
        }
    }
}

  deselectFolder(folder: any) {
    if (folder.type === 'Folder') {
      const folderFiles = folder.files;
      folderFiles.forEach((file: any) => {
        const index = this.selectedDocs.indexOf(file);
        if (index >= 0) {
          this.selectedDocs.splice(index, 1);
        }
      });
    }
  }

//DELTA TABLES METHODS

getAllDeltaTables(type?:string) {
  this.loadmoreLoadingTables=true
  this.pageSizeTables=15
  this.selectedTables = [];
  let search = this.searchText ? this.searchText : '';
  let params = {
      pageSize: this.pageSizeTables,
  };
  if (type == 'loadmore') {
      this.loadmoreLoading = true;
      params['loadMore']=true
      params['markerId'] = this.deltaTablesList[this.deltaTablesList.length - 1]['_id'];
  }
  if (type == 'search') {
      (params['search'] = this.searchText);
  }
  if (type == 'reload') {
      params.pageSize = this.deltaTablesList.length;
  }
  if(!type){
      this.deltaTablesList=[]
  }
  this.getAllDocsSub.add(
      this.docService.getAllDeltaTables(params).subscribe({
          next: (response: IDeltaTable[]) => {
              this.isloadingTables = false;
              this.loadmoreLoading=false;
              if (response.length < this.pageSizeTables) {
                  this.showLoadMoreTables = false;
              }
              if(type == 'reload'||type == 'search'){
                  this.deltaTablesList=response
              }else{
                  this.deltaTablesList = [...this.deltaTablesList, ...response];
              }
              if (this.activeChat?.chatTables?.length > 0) {
                  this.deltaTablesList.map((e: IDeltaTable) => {
                      const foundItem = this.activeChat.chatTables.find(
                          (table:IDeltaTable) =>
                            table.tableId === e.tableId,
                      );
                      if (foundItem) {
                          this.selectedTables.push(e);
                      }
                  });

              }
          },
          error: (error) => {
              this.loadmoreLoadingTables=false;
              this.isloadingTables = false;
          },
      }),
  );
}


// ESG Logic

getUniqueCategoriesTables(){
  if(this.tablesListByCategory.length == 0){
  this.getUnqCategoriesSub.add(
    this.docService.getUniqueESGTableCategories().subscribe({
      next:(response:string[] )=>{
        this.unqTableCategories = []
        this.tablesListByCategory = []
        this.unqTableCategories = response
        this.unqTableCategories.map((e:string)=>{
              this.tablesListByCategory.push({
                category : e,
                tables: [],
                categorySelection : false
              })
              this.expandedESGRowKeys[e] = false
        })
        this.populateESGChatTables(this.activeChat)
        this.isloading = false;
      },
      error(err) {
        console.log(err)
        this.isloading = false;
      },
    })
  )}else{
    this.isloading = false
  }
}

async getListOfTablesForCategory(category: string): Promise<IDeltaTable[]> {
  return new Promise((resolve, reject) => {
    this.docService.getListOfESGTablesForCategory(category).subscribe({
      next: (response: IDeltaTable[]) => {
        resolve(response);
      },
      error: (err) => {
        console.log(err);
        this.loadmoreLoading = false;
        this.isloading = false;
        reject(err);
      },
    });
  });
}

async onRowExpand(event) {
  const category = event.data.category;
  const categoryIndex = this.tablesListByCategory.findIndex(table => table.category === category);

  if (categoryIndex !== -1 && this.tablesListByCategory[categoryIndex].tables.length === 0) {
    const catTablesList = await this.getListOfTablesForCategory(category);
    this.tablesListByCategory[categoryIndex].tables = catTablesList;
  }
}

populateESGChatTables(activeChat : IChat){
  if(this.activeChat?.chatTables?.length > 0 && this.tablesListByCategory?.length > 0){
    this.activeChat?.chatTables.map(async (e:IDeltaTable)=>{
      this.expandedESGRowKeys[e.category] = true
      const categoryIndex = this.tablesListByCategory.findIndex(table => table.category === e.category);
      if( this.tablesListByCategory[categoryIndex]?.tables?.length === 0){
        await this.onRowExpand({data:{category:e.category}})
      }
      if( this.tablesListByCategory[categoryIndex]?.tables?.length > 0){
        let tempTable = this.tablesListByCategory[categoryIndex]?.tables?.filter(table=>table.tableId === e.tableId)
        if(tempTable.length > 0){
          this.selectedTables.push(tempTable[0])
        }
      }
    })
  }
}

toggleCategorySelection(event:any,category: string, tables :IDeltaTable[], categorySelection:boolean): void {
  if (!categorySelection) {
    // Deselect all rows in the category
    this.selectedTables = this.selectedTables.filter(row => row.category !== category);
  } else {
    // Select all rows in the category
    tables.forEach(row => {
      if (!this.selectedTables.includes(row)) {
        this.selectedTables=[...this.selectedTables,...[row]];
      }
    });
  }
}

checkMultipleSourcesSelection(){
  let isDisabled = false;
  if(this.selectedTables.length > 0){
      let selectedSource = this.selectedTables[0].source
      this.selectedTables.map((e:IDeltaTable)=>{
        if(selectedSource !== e.source){
          isDisabled = true
        }
    })
  }
  return isDisabled
}


checkESGFiltersEmitter(event:any){
  if(this.selectedTables.length > 0){
    event['deltaTables'] = this.selectedTables
  }
  this.emitChangeSelectedESGFilters.emit(event);
}


}
